// load this module if present in DOM

import $ from "jquery";
import plugin from "@core/plugins/lib";
import { onAvailable } from '@core/plugins/lib/selectors';

const ELEMENT_SELECTOR = '[data-afterpay-payment]';
const PLUGIN_NAME = 'afterpayPayment';

$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function(element) {
		System.import(/* webpackChunkName: "afterpay-payment" */ './afterpay-payment').then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/afterpay-payment/plugin--available.js